import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 8px 0;
    text-align: left;
  `};
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    text-align: left;
  `};
`;

export const OptionsWrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    list-style-type: none;
    margin: 40px 0px 0px 0px;
    width: 100%;
    max-width: 930px;
    max-height: 430px;
    overflow: auto;
    padding: 0px;
    align-items: stretch;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 0px 0px 0px;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highMedium};
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.v2.colors.neutral.highMedium};
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    width: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;

    &.checked{
      border-color: ${theme.v2.colors.brand.primaryBlue};
    }
  `};
`;

export const RadioLabel = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionRow = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    
    button {
      padding: 2.5px;
    }
  `}
`;

export const OptionTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0 0 0 24px;
    text-align: left;
    word-break: break-all;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px 0;
  `};
`;

export const OptionSubTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    word-break: break-all;
    display: block;
    text-align: left;
  `};
`;
